import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const GET_TISA_FOREX_RATE_CATEGORY = `${API_URL}/tisa-forex-rate-category`

export const service = {
  getTisaForexRateCategory: (params: ParamsModel) => {
    return axios.get(GET_TISA_FOREX_RATE_CATEGORY, {params})
  },
}
